import GuardedComponent from "./GuardedComponent";

export default GuardedComponent;
